//prettier-ignore
export const ARJIV_EXPORTS_URL = "https://arjivexports.com";
export const TRADE_ARJIV_URL = "https://trade.arjivexports.com";

export const APP_STORE_APP_URL =
  "https://apps.apple.com/us/app/arjiv-exports/id1557607725";
export const PLAY_STORE_APP_URL =
  "https://play.google.com/store/apps/details?id=com.arjiv.app";

export const SKYPE_URL = "skype:live:.cid.5f5ec33ba48feb87?chat";
export const FACEBOOK_URL = "https://www.facebook.com/arjivexportsnyc";
export const INSTAGRAM_URL = "https://www.instagram.com/arjivexportsnyc";
export const LINKEDIN_URL = "https://in.linkedin.com/company/arjiv-diamonds";
export const WHATSAPP_URL = "https://api.whatsapp.com/send?phone=+917405793333&text=I%27m%20Interested%20in%20buying%20Diamonds%20from%20you";

export const SURAT_OFFICE_URL = "https://maps.app.goo.gl/orzEfe6SoRdoUQb58";
export const MUMBAI_OFFICE_MAP = "https://maps.app.goo.gl/pzRqkeTYQ43yMdRg8";

export const ARJIV_EMAIL_URL = "mailto:surat@arjiv.com";
export const ARJIV_INFO_EMAIL_URL = "mailto:info@arjiv.com";

export const CALL_URL = "tel:+919898300984";

export const moduleTypes = {
  NEXT_TRADESHOW: 2,
  NEXT_EXHIBITIONS: 1,
};

